<template>
  <div class="specialItem_body">
    <div class="item_top">
      <div class="area">
        <p>{{ specialItem.regionFullName }}</p>
      </div>
      <div class="buttons_top">
        <div class="guide" @click="getGuide">
          <img src="../static/operate-guide.png" alt="" />
          备考指南
        </div>
        <div class="option">
          <el-dropdown @command="dropCommand">
            <el-button plain class="dropdown_btn">
              <div>
                <img src="../static/ellipsis.png" alt="" />
                操作
              </div>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item style="color: #0094ff;font-size:14rem" command="1"
                >编辑地区</el-dropdown-item
              >
              <el-dropdown-item style="color: #fe1d1d;font-size:14rem" command="2"
                >禁用地区</el-dropdown-item
              >
              <el-dropdown-item style="color: #fe1d1d;font-size:14rem" command="3"
                >删除地区</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="guide topic" @click="questionVisible = true">
          <img src="../../../assets/images/icon-add.png" alt="" />
          新增题源
        </div>
      </div>
    </div>

    <div class="item_middle">
      <questionItem 
        v-for="(item,index) in bookList" 
        :key="index"
        :bookItem="item"
        :region="specialItem.regionFullName"
        @initAfterEdit="initAfterEdit"
      ></questionItem>
    </div>

    <div class="item_footer" v-if="bottomShow">
      <el-pagination
        :total="totle"
        :page-size="pageParams.pageSize"
        :current-page.sync="pageParams.pageNum"
        :background="true"
        layout="prev, slot, next"
        prev-text="< 上一页 "
        next-text="下一页 >"
      >
        <span
          ><b>{{ pageParams.pageNum }}</b
          >/{{ totalPage }}</span
        >
      </el-pagination>
    </div>

    <!--备考指南对话框-->
    <el-dialog :visible.sync="guideVisible" width="690rem" class="guideDia">
      <div slot="title">
        <div class="dia-title">
          <div class="dia-title-before"></div>
          <div class="dia-title-text">备考指南</div>
        </div>
      </div>
      <div class="content-box">
        <div
          class="content-title"
          v-for="(item, index) in guideList"
          :key="index"
        >
          <P>{{ item.bookName }}</P>
          <el-input
            type="textarea"
            placeholder="请输入文字"
            v-model="item.description"
            rows="2"
            resize="none"
          >
          </el-input>
        </div>
      </div>
      <div class="save-button" @click="saveGuide">保存</div>
    </el-dialog>

    <!--新增题源对话框-->
    <el-dialog
      :visible.sync="questionVisible"
      width="380rem"
      class="questionDia"
    >
      <div slot="title">
        <div class="dia-title">
          <div class="dia-title-before"></div>
          <div class="dia-title-text">新增题源</div>
        </div>
      </div>
      <div class="question-content">
        <span class="red-star-icon">*</span>
        <p>题源：</p>
        <el-input placeholder="请输入题源名称" v-model="questionForm.name">
        </el-input>
      </div>
      <div class="question-content">
        <!-- <span class="red-star-icon">*</span> -->
        <p class="from-item-lable">备注：</p>
        <el-input placeholder="请简要描述" v-model="questionForm.note">
        </el-input>
      </div>
      <div class="question-content">
        <p class="from-item-lable">启用：</p>
        <el-switch
          v-model="questionForm.status"
          active-color="#0BAE6A"
          inactive-color="#eeeeee"
        >
        </el-switch>
      </div>
      <div
        class="save-button"
        :class="{ 'diable-btn': qusBtnDisabled }"
        @click="createQuestion"
      >
        保存
      </div>
    </el-dialog>

    <!--编辑地区对话框-->
    <el-dialog :visible.sync="areaVisible" width="380rem" class="areaDia">
      <div slot="title">
        <div class="dia-title">
          <div class="dia-title-before"></div>
          <div class="dia-title-text">编辑地区</div>
        </div>
      </div>
      <div class="area-content">
        <span class="red-star-icon">*</span>
        <p>地区：</p>
        <el-cascader
          :options="filterArr"
          v-model="districtForm.areaId"
          clearable
          :props="{ expandTrigger: 'hover' }"
          placeholder="请选择地区"
        >
        </el-cascader>
      </div>
      <div class="area-content">
        <p class="from-item-lable">启用：</p>
        <el-switch
          v-model="districtForm.status"
          active-color="#0BAE6A"
          inactive-color="#eeeeee"
        >
        </el-switch>
      </div>
      <div
        class="save-button"
        :class="{ 'diable-btn': btnDisabled }"
        @click="editDistrictOpt"
      >
        确定
      </div>
    </el-dialog>

    <!-- 遮罩层 -->
    <div class="mask" v-if="mask">
      <el-button @click="disableDistrict(false)">启用地区</el-button>
      <img class="image" src="../static/forbidden.png" />
    </div>
    <el-empty
      description=" "
      :image-size="200"
      :image="require('../static/empty.png')"
      v-if="empty"
    ></el-empty>
  </div>
</template>
<script>
import questionItem from "./questionItem.vue";
import {
  addOrEditDistrict,
  getGuideOpt,
  saveGuideOpt,
  updateDistrictStatus,
  createQuestionOpt,
  deleteRegion
} from "@/api/special";
export default {
  name: "specialItem",
  components: {
    questionItem,
  },
  computed: {
    totalPage() {
      return Math.ceil(this.totle / this.pageParams.pageSize);
    },
  },
  watch: {
    specialItem: {
      handler(newVal) {
        this.totle = newVal.bookList.length;
        this.bookList = newVal.bookList.slice((this.pageParams.pageNum-1)*this.pageParams.pageSize, this.pageParams.pageNum*this.pageParams.pageSize)
        if (!this.totle) {
          this.bottomShow = false;
        } else {
          this.bottomShow = true;
        }
        if (newVal.bookList.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.mask = newVal.status=="0"?false:true
      },
      deep: true,
      immediate: true,
    },

    districtForm: {
      handler(val) {
        if (val.areaId.length > 0) {
          this.btnDisabled = false;
        } else {
          this.btnDisabled = true;
        }
      },
      deep: true,
      immediate: true,
    },

    "questionForm.name": {
      handler(val) {
        if (val) {
          this.qusBtnDisabled = false;
        } else {
          this.qusBtnDisabled = true;
        }
      },
      immediate: true,
    },

    "pageParams.pageNum": {
      handler(val) {
        this.bookList = this.specialItem.bookList.slice((val-1)*this.pageParams.pageSize, val*this.pageParams.pageSize)
      },
      immediate: true,
    },
  },
  props: {
    filterArr: {
      type: Array,
    },
    specialItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      guideVisible: false,
      questionVisible: false,
      areaVisible: false,
      text: "",
      mask: false,
      bottomShow: true,
      btnDisabled: true,
      qusBtnDisabled: true,
      empty: false,
      totle: 10,
      status: "",
      bookList:[],
      guideList: [],
      questionForm: {
        name: "",
        note: "",
        status: true,
      },
      districtForm: {
        areaId: 0,
        status: true,
      },
      pageParams: {
        pageSize: 2,
        pageNum: 1,
      },
    };
  },
  methods: {
    dropCommand(command) {
      if (command == "1") {
        this.editDistrict();
      }
      if (command == "2") {
        this.disableDistrict(true);
      }
      if (command == "3") {
        console.log(this.districtForm)
        console.log(this.specialItem)
        this.delRegion();
      }
    },
    delRegion(){
      this.$confirm("删除后，数据将被清除无法恢复", "是否删除当前地区？", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        customClass: "customClass_1",
        confirmButtonClass: "btnConfirm",
        cancelButtonClass: "btnCancel",
      })
        .then(() => {
          deleteRegion({
            regionId: this.specialItem.id
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.$emit("updateRegionData");
            } else {
              this.$message.error(res.info);
            }
          });
        })
        .catch(() => {});
    },
    disableDistrict(flag) {
      let msg1 = flag
        ? "禁用后，将关闭该地区下题源、模块等各级启用权限"
        : "启用后，还需打开该地区下题源、模块等各级启用权限";
      let msg2 = flag ? "是否禁用当前地区?" : "是否启用当前地区？";
      this.$confirm(msg1, msg2, {
        distinguishCancelAndClose: true,
        confirmButtonText: flag ? "禁用" : "启用",
        cancelButtonText: "取消",
        customClass: "customClass_1",
        confirmButtonClass: "btnConfirm",
        cancelButtonClass: "btnCancel",
      })
        .then(() => {
          let status = flag ? "1" : "0";
          updateDistrictStatus({
            id: this.specialItem.id,
            status: status,
          }).then((res) => {
            if (res.code == 0) {
              this.mask = flag ? true : false;
              this.$message.success(flag ? "禁用成功" : "启用成功");
              this.$emit("initAfterEdit");
            } else {
              this.$message.error(res.info);
            }
          });
        })
        .catch(() => {});
    },

    editDistrict() {
      this.areaVisible = true;
      this.districtForm.areaId = this.specialItem.areaIdNodes;
      this.districtForm.status = this.specialItem.status == "0" ? true : false;
      this.districtForm.id = this.specialItem.id;
    },

    editDistrictOpt() {
      if (!this.btnDisabled) {
        let form = {};
        form.areaId =
          this.districtForm.areaId[this.districtForm.areaId.length - 1];
        form.status = this.districtForm.status ? "0" : "1";
        form.id = this.districtForm.id;
        addOrEditDistrict(form).then((res) => {
          if (res.code == 0) {
            this.$message.success("修改成功");
            this.districtForm = {
              areaId: 0,
              status: true,
            };
            this.areaVisible = false;
            this.$emit("initAfterEdit");
          } else {
            this.$message.error(res.info);
          }
        });
      }
    },

    getGuide() {
      this.guideVisible = true;
      getGuideOpt({ regionId: this.specialItem.id }).then((res) => {
        if (res.code == 0) {
          this.guideList = res.data;
        }
      });
    },

    saveGuide() {
      saveGuideOpt(this.guideList).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
          this.guideList = [];
          this.guideVisible = false;
          this.$emit("initAfterEdit");
        } else {
          this.$message.error(res.info);
        }
      });
    },

    createQuestion() {
      if(this.questionForm.note.length>10){
        this.$message.warning("备注字数不能超过10个");
        return;
      }
      if (!this.qusBtnDisabled) {
        let form = {};
        form.regionId = this.specialItem.id;
        form.name = this.questionForm.name;
        form.note = this.questionForm.note;
        form.status = this.questionForm.status ? "0" : "1";
        createQuestionOpt(form).then((res) => {
          if (res.code == 0) {
            this.$message.success("新增成功");
            this.questionForm = {
              name: "",
              note: "",
              status: true,
            };
            this.questionVisible = false;
            this.$emit("initAfterEdit");
          }else{
            this.$message.success(res.info);
          }
        });
      }
    },

    initAfterEdit(){
      this.$emit("initAfterEdit");
    }
  },
};
</script>

<style lang="scss" scoped>
.specialItem_body {
  position: relative;
  width: 805rem;
  height: 553rem;
  background: #f5f5f5;
  border-radius: 12rem;
  .item_top {
    padding: 20rem 20rem 0rem 0rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .buttons_top {
      width: 40%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 10;
    }
    .area {
      width: 180rem;
      height: 48rem;
      line-height: 48rem;
      border-top-right-radius: 22.5rem;
      border-bottom-right-radius: 22.5rem;
      background-image: var(--background-image);
      p {
        margin: 0rem;
        white-space: nowrap;
        overflow: hidden;
        line-height: 44rem;
        height: 48rem;
        margin-left: 30%;
        color: #fff;
        font-size: 20rem;
      }
      p::before {
        content: "";
        width: 32rem;
        height: 32rem;
        background: url("../static/locate.png") center no-repeat;
        position: absolute;
        left: 2%;
        top: 26rem;
      }
    }
    .guide {
      cursor: pointer;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100rem;
      height: 32rem;
      border: 1rem solid rgb(153, 153, 153);
      border-radius: 3rem;
      background: #fff;
      font-size: 14rem;
      img {
        height: 16rem;
        width: 16rem;
        margin-right: 3rem;
      }
    }
    .option {
      .dropdown_btn {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        height: 32rem;
        color: #666666;
        font-size: 14rem;
        border: 1rem solid #999999;
        &:hover {
          color: #666666;
        }
        div {
          display: flex;
          align-items: center;
          img {
            height: 16rem;
            width: 16rem;
            margin-right: 3rem;
          }
        }
      }
    }
    .topic {
      color: var(--primary-color);
      border-color: var(--primary-color);
    }
  }

  .item_middle {
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    margin-top: 20rem;
    flex-wrap: wrap;
    padding: 0rem 20rem;
  }

  .item_footer {
    display: flex;
    justify-content: center;
    padding-top: 20rem;
    z-index: 10;
    span {
      margin-left: 16rem;
      b {
        color: var(--primary-color);
      }
    }
  }
  .guideDia {
    display: flex;
    flex-direction: column;
    .content-box{
      height: calc(100% - 50rem);
      overflow:auto;
      // border: 1rem solid #E9E9E9;
      box-sizing:border-box;
      // background:#fff;
      border-radius: 10rem;
    }
    ::-webkit-scrollbar {
      width: 8rem;
    }
    ::-webkit-scrollbar-thumb{
      border-radius: 6rem;
      background-color: #d9d9d9;
    }
    .content-title {
      // margin-bottom: 12rem;
      background: #D5FAE0;
      line-height: 40rem;

      ::v-deep .el-textarea__inner {
        height: 105rem;
        border: unset;
      }
      p {
        // margin-bottom: 4rem;
        // font-size: 14rem;
        font-weight: bold;
        padding: 8rem 12rem;

        font-size: 16rem;
        color: #0BAE6A;
        // line-height: 19rem;
      }
    }
    ::v-deep .el-dialog {
      height: 625rem;
    }
  }
  .questionDia {
    ::v-deep .el-dialog {
      height: 275rem;
    }
    .question-content {
      display: flex;
      align-items: center;
      margin-bottom: 20rem;
      p {
        width: 60rem;
        font-size: 14rem;
      }
    }
    ::v-deep .el-input__inner {
      height: 32rem;
    }
  }
  .areaDia {
    ::v-deep .el-dialog {
      height: 351rem;
      display: flex;
      flex-direction: column;
      margin: 0 !important;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 10rem;
      background: #f5f5f5;
    }
    .area-content {
      display: flex;
      align-items: center;
      margin-bottom: 20rem;
      p {
        width: 50rem;
        font-size: 14rem;
      }
    }
    ::v-deep .el-input__inner {
      height: 32rem;
    }
  }

  .save-button {
    position: absolute;
    right: 20rem;
    bottom: 20rem;
    width: 72rem;
    height: 32rem;
    line-height: 32rem;
    font-size: 14rem;
    color: #fff;
    background: var(--primary-color);
    border-radius: 4rem;
    display: flex;
    justify-content: center;
    cursor: pointer;
  }
  .diable-btn {
    background: #b7e7d3;
  }
  .mask {
    position: absolute;
    border-radius: 10rem;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* 按钮居中 */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 50;
    .el-button {
      color: #fff;
      background-image: var(--background-image);
      border: none !important;
      border-radius: 6rem;
      box-shadow: none !important;
      font-size: 22rem;
      width: 136rem;
      height: 58rem;
    }
    .image {
      width: 120rem;
      height: 120rem;
      position: absolute;
      top: -28rem;
      right: -28rem;
    }
  }
  .el-empty {
    position: absolute;
    border-radius: 10rem;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
}
::v-deep .el-textarea__inner,
::v-deep .el-input__inner {
  &:focus {
    border: 1px solid var(--primary-color);
  }
  &:hover {
    border: 1px solid var(--primary-color);
  }
}
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10rem;
  background: #f5f5f5;
}
.el-dropdown-menu__item:hover {
  background-color: #e9e9ea;
}

// Dialog关闭按钮
::v-deep .el-dialog__headerbtn:focus .el-dialog__close,
::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
  color: var(--primary-color) !important;
}

::v-deep .el-dialog__body {
  padding: 20rem 20rem 30rem 20rem;
  // height: calc(100% - 180rem);
  overflow: auto;
  height: 100%;
}
.red-star-icon{
  font-size:14rem;
  color:#FF0000;
  margin-right:5rem;
}
.from-item-lable{
  margin-left: 14rem;
}
</style>
<style lang='scss'>
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: var(--primary-color);
}
</style>